// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jecgC","col":"styles_col__CtDdx"};